import React from "react";
import { FaRegLightbulb, FaUserShield, FaRocket } from "react-icons/fa";

const HowItWorks = () => {
  const steps = [
    {
      icon: <FaRegLightbulb size={24} />,
      title: "Take Control in Under a Minute",
      desc: "Log your expenses, loans, and subscriptions effortlessly — start owning your money, not chasing it.",
    },
    {
      icon: <FaUserShield size={24} />,
      title: "Let AI Do the Heavy Lifting",
      desc: "Get personalized insights, reminders, and saving tips — without crunching a single number yourself.",
    },
    {
      icon: <FaRocket size={24} />,
      title: "See Your Goals Become Reality",
      desc: "Watch your progress grow, celebrate milestones, and stay motivated every step of the way.",
    },
  ];

  return (
    <section id="how-it-works" className="section">
      <div className="container flex justify-center max-w-[1440px] mx-auto mb-12">
        <div
          className="absolute inset-0 -z-10 bg-gradient-to-b from-transparent via-indigo-500/5 to-transparent"
          aria-hidden
        />
        <div className="container-site text-center">
          <span className="eyebrow mb-3">Simple as 1-2-3</span>
          <h2 className="heading-2">How It Works</h2>
          <p className="subheading">
            Get started in minutes and see results from day one.
          </p>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {steps.map((s, idx) => (
              <div
                key={idx}
                className="group relative card-glass p-6 text-left transition-transform hover:-translate-y-1"
              >
                <div
                  className="absolute inset-0 -z-10 rounded-2xl bg-gradient-to-br from-indigo-500/0 via-sky-500/0 to-cyan-500/0 opacity-0 group-hover:opacity-100 transition-opacity"
                  aria-hidden
                />
                <div className="inline-flex items-center justify-center w-11 h-11 bg-indigo-600 text-white shadow ring-1 ring-white/10 shadow-[0_0_22px_rgba(79,70,229,0.32)]">
                  {s.icon}
                </div>
                <h3 className="mt-4 text-white font-bold text-lg">
                  {idx + 1}. {s.title}
                </h3>
                <p className="mt-2 text-gray-300 text-sm leading-relaxed">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="overflow-hidden">
            <img
              className="image-fade rounded-2xl border-b-0 border-[2px] border-white/15 mt-24"
              src="assets/calendar.png"
              alt="ddashboard"
              style={{ transform: "scale(1)" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
